import axios from "axios";
import { Base_URL } from "../url";

export const saveTicketTimeCard = async (timeCardData, userName) => {
  try {
    const apiData = {
      ticketId: timeCardData.LogId, // This will be the logId (hidden from user)
      date: timeCardData.Date,
      projectCode: timeCardData.ProjectCode,
      hours: timeCardData.Hours,
      tasks: timeCardData.Tasks,
      remarks: timeCardData.Remarks,
      location: timeCardData.Location
    };

    const response = await axios.post(
      `${Base_URL}/TicketTimecard/CreateTicketTimecard?UserName=${userName}`,
      apiData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving ticket time card!";
  }
};

export const getTicketLogs = async (email, date) => {
  try {
    const response = await axios.get(
      `https://pmbackendcode.techsaisatwik.in/api/tasks/logs/by-user-date/${email}/${date}`,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching ticket logs:", error);
    throw error.response?.data || "Error fetching ticket logs!";
  }
};

/* import axios from "axios";
import { Base_URL } from "../url";

export const saveTicketTimeCard = async (timeCardData, userName) => {
  try {
    const apiData = {
      ticketId: timeCardData.TicketId, 
      date: timeCardData.Date,
      projectCode: timeCardData.ProjectCode,
      hours: timeCardData.Hours,
      tasks: timeCardData.Tasks,
      remarks: timeCardData.Remarks,
      location: timeCardData.Location
    };

    const response = await axios.post(
      `${Base_URL}/TicketTimecard/CreateTicketTimecard?UserName=${userName}`,
      apiData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving ticket time card!";
  }
};

export const getTicketLogs = async (email, date) => {
  try {
    const response = await axios.get(
      `https://pmbackendcode.techsaisatwik.in/api/tasks/logs/by-user-date/${email}/${date}`,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching ticket logs:", error);
    throw error.response?.data || "Error fetching ticket logs!";
  }
}; */
